/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForAlertsOci extends models.GovernanceConfigurationBaseForAlerts {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForAlertsOci");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForAlertsOci.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForAlertsOci>): GovernanceConfigurationForAlertsOci {
        let obj = Object.assign(new GovernanceConfigurationForAlertsOci(), model);
        GovernanceConfigurationForAlertsOci.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForAlertsOci>): GovernanceConfigurationForAlertsOci {
        if (!model) return null;
        return GovernanceConfigurationForAlertsOci.newInstance(<GovernanceConfigurationForAlertsOci> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForAlertsOci) {
        if (!obj) return;

        models.GovernanceConfigurationForAlertsOci.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForAlertsOci): boolean {
        if (models.GovernanceConfigurationBaseForAlerts.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForAlertsOci.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Region Id
     */
    region: string;

    /**
     * Topic Name
     */
    topic_name: string;

}
